import routerOptions0 from "/var/www/frontend_build/node_modules/.pnpm/nuxt@3.20.1_@parcel+watcher@2.5.1_@types+node@24.10.0_@vue+compiler-sfc@3.5.24_db0@0.3.4_esli_use47k75taj4y6vnoejk7oouzq/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}